<template>
  <div>
    <head-nav-bar
      title="客户列表"
      :fixed="true"
      @click-left="toindex"
      rightText="新增"
      @click-right="addUser"
    />
    <div class="mt-header-nav">
      <van-search
        v-model="keyword"
        placeholder="请输入客户姓名/编号"
        show-action
        shape="round"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
      <DataList :api="api" :params="listParams">
        <template v-slot:item="item">
          <div @click="userDetail(item.Id)">
            <van-cell :title="item.Name" :label="item.Code" is-link />
          </div>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import { getUserList } from "@/api/user.js";
import DataList from "@/components/DataList";
import { Notify, Search, Cell, CellGroup } from "vant";
export default {
  name: "UserList",
  components: {
    DataList,
    [Notify.name]: Notify,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      keyword: "",
      listParams: {},
      api: getUserList,
    };
  },
  created() {
    getUserList({ PageIndex: 0 }).then(() => {});
  },
  methods: {
    toindex() {
      this.$router.push({
        name: "workplace",
      });
    },
    onSearch() {
      this.listParams = {
        Name: this.keyword,
      };
    },
    userDetail(id) {
      this.$router.push({ name: "UserDetail", query: { id: id } });
    },
    addUser() {
      this.$router.push({ name: "EditUser", query: { type: 1 } });
    },
  },
};
</script>
